var _excluded = ["children", "className", "fluid", "small", "medium", "large"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './style.scss';
var Container = function Container(props) {
  var children = props.children,
    className = props.className,
    fluid = props.fluid,
    small = props.small,
    medium = props.medium,
    large = props.large,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('Container', className, {
    container: !fluid,
    'container--small': small,
    'container--medium': medium,
    'container--large': large,
    'container--fluid': fluid
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, restProps), children);
};
Container.defaultProps = {
  small: false,
  medium: false,
  large: false,
  fluid: false,
  children: null,
  className: ''
};
Container.propTypes = {
  small: PropTypes.bool,
  medium: PropTypes.bool,
  large: PropTypes.bool,
  fluid: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string
};
export default Container;